// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"41b01473","35":"0c261a7f","47":"d48281ea","99":"1bffa54f","216":"ac2a2ff9","272":"20f90150","390":"02445bba","436":"64f20866","439":"9f96da97","488":"10f3046d","627":"929d15a3","653":"9709455e","695":"dfff893d","890":"2e9a6b18"}[chunkId] + ".chunk.js";
};